module.exports = __webpack_public_path__ + "media/Suspense_Horror_Movie.fd64443b.wav";